import { simpleReducer } from './reducerHelpers'

export default simpleReducer({
	default: 										null,
	value_received_dbVersion:   'PAYLOAD',
})



// WEBPACK FOOTER //
// ./src/reducers/dbVersion.js